import React from 'react';

import { Popconfirm, Switch } from 'antd';
import Icon, {
  CloseOutlined, InfoCircleOutlined,
} from '@ant-design/icons';
import { SortableElement, SortableHandle, SortableElementProps } from 'react-sortable-hoc';

import { ReactComponent as DragIcon } from '../../../../assets/icons/dragHandle.svg';

interface IWithActionsContainerProps extends SortableElementProps {
  children: React.ReactNode;
  active: boolean;
  containerExtraClassNames?: string[];
  // eslint-disable-next-line
  overStyle: any;
  onDelete?: () => void;
  onInfoClick?: () => void;
  onActiveChange: () => void;
}

const DragHandle = SortableHandle(() => <Icon component={DragIcon} className="rule-drag-handler" />);
// eslint-disable-next-line
const previous: any[] = [];

// eslint-disable-next-line
const getOverTarget = (element: any) => {
  if (!element.classList.contains('with-actions-container')) {
    return element.currentTarget.closest('.with-actions-container');
  }
  return element;
};

const clearOverInStack = () => {
  let ce = previous.pop();
  while (ce != null) {
    ce.style['background-color'] = null;
    ce = previous.pop();
  }
};

const WithActionsContainer = ({
  onDelete,
  children,
  containerExtraClassNames = [],
  overStyle,
  onInfoClick,
  active,
  onActiveChange,
}: IWithActionsContainerProps): JSX.Element => (
  // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
  <div
    className={`with-actions-container ${containerExtraClassNames.join(' ')}`}
    style={{ display: 'flex', flexDirection: 'row' }}
    onMouseOver={(e) => {
      e.stopPropagation();
      clearOverInStack();
      const target = getOverTarget(e.currentTarget);
      target.style['background-color'] = overStyle.backgroundColor;
      previous.push(target);
    }}
    onMouseLeave={(e) => {
      e.stopPropagation();
      clearOverInStack();
    }}
  >
    <div
      style={{
        display: 'flex', flexDirection: 'row', padding: '5px', gap: '4px',
      }}
    >
      <Switch checked={active} onChange={onActiveChange} />
      <DragHandle />
    </div>
    <div style={{
      display: 'flex', flexDirection: 'column', width: '100%', gap: '4px',
    }}
    >
      {children}
    </div>
    <div
      style={{
        display: 'flex', flexDirection: 'row', padding: '5px', gap: '4px',
      }}
    >
      {onInfoClick && (
        <InfoCircleOutlined onClick={() => onInfoClick && onInfoClick()} />
      )}
      <Popconfirm
        title="Are you sure to delete this rule?"
        onConfirm={onDelete}
        okText="Yes"
        cancelText="No"
      >
        <CloseOutlined />
      </Popconfirm>
    </div>
  </div>
);

export default SortableElement<IWithActionsContainerProps>(WithActionsContainer);
